"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 6a6 6 0 100 12 6 6 0 000-12zm.467 8.936h-.934v-.934h.934v.934zm0-1.878h-.934V9.064h.934v3.994z" }), "Alert");
//# sourceMappingURL=Alert.js.map